/** Shared surface styles for profile screens — cards pop against the wash page bg. */
export const profileCard =
  'rounded-[22px] border border-black/[0.08] bg-card shadow-[0_4px_20px_-8px_rgba(20,20,50,0.14),0_1px_3px_rgba(20,20,50,0.06)]';

export const profilePanel =
  'overflow-hidden rounded-[22px] border border-black/[0.08] bg-card shadow-[0_4px_20px_-8px_rgba(20,20,50,0.14),0_1px_3px_rgba(20,20,50,0.06)]';
